<template>
  <span v-if="dataSource.id">
    <a-space v-if="brType !== 21">
      <template v-if="dataSource.status === 134">
        <br-team-assess-modal :br-id="dataSource.id" />
        <a-button v-if="false" type="primary" :disabled="dataSource.claimant && dataSource.claimant > 0" @click="brClaim"> 需求认领 </a-button>
      </template>
      <template v-if="[134, 135, 136, 137].includes(dataSource.status)">
        <br-assess-confirm-modal :br-id="dataSource.id" @ok="onOk" />
      </template>
      <a-button v-if="dataSource.status >= 134 && (isProductPo || isTechnicalManager)" v-tc="{ name: '应用价值追溯' }" type="primary" @click="openRetrospect"> 应用价值追溯 </a-button>
      <a-button v-if="dataSource.status === 134 && !dataSource.read" v-tc="{ name: '标记为已读' }" type="primary" @click="readBr">标记为已读</a-button>
      <a-button v-if="dataSource.status >= 134 && dataSource.read" v-tc="{ name: '已读列表' }" type="primary" @click="openReadList">已读列表</a-button>
      <evaluation-btn v-if="dataSource.status >= 139" :data-source="dataSource" />
      <a-button v-tc="{ name: '编辑' }" type="primary" @click="onEdit">编辑</a-button>
      <a-button v-if="false" type="primary">提交审核</a-button>
      <!-- 并且没有未完成的评审 -->
      <a-button v-if="dataSource.status >= 134 && reviewInfos && reviewInfos.length > 0" v-tc="{ name: '会议记录' }" type="primary" @click="openReviewLog">会议记录</a-button>
      <a-button v-if="dataSource.status === 134 && reviewPermission" v-tc="{ name: '发起线下评审' }" :disabled="!canReview" type="primary" @click="openReview">发起线下评审</a-button>
      <a-dropdown>
        <a-menu slot="overlay">
          <a-menu-item v-if="isProductPo" key="1" @click="onBack"> 退回 </a-menu-item>
          <a-menu-item v-if="isProductPo || isCrator" key="4" @click="onInvalid"> 作废 </a-menu-item>
        </a-menu>
        <a-button> 更多 <a-icon type="down" /> </a-button>
      </a-dropdown>
    </a-space>
    <a-space v-if="brType === 21">
      <a-button v-tc="{ name: '编辑' }" type="primary" @click="onEdit">编辑</a-button>
      <a-dropdown>
        <a-menu slot="overlay">
          <a-menu-item v-if="isCrator" key="4" @click="onInvalid"> 作废 </a-menu-item>
        </a-menu>
        <a-button> 更多 <a-icon type="down" /> </a-button>
      </a-dropdown>
    </a-space>
    <add-or-edit ref="addOrEditRef" :br-type="brType" @saveOK="onOk" />
    <ReviewModal ref="reviewModalRef" :is-show="modalVisible" :is-mrd="true" @close="close" @addOk="getReviewInfo()" />
    <ActionRecordModal ref="actionRecordRef" />
    <FsReviewLogs ref="fsReviewLogsRef" @changeStatus="getReviewInfo()" />
    <RetrospectModal ref="retrospectModalRef" :data-source="dataSource" @saveOk="onOk()" />
    <InvalidModal ref="invalidModalRef" :data-source="dataSource" @saveOk="onOk()" />
    <BackModal ref="backModalModalRef" :data-source="dataSource" @saveOk="onOk()" />
  </span>
</template>

<script>
import { teamList } from '@/api/system/team';
import { addActionRecord } from '@/api/business/document';
import { queryReviewByBuReqId, businessRequirementClaim } from '@/api/business/requirement';

import AddOrEdit from '@/pages/business/requirement/AddOrEdit';
import FsReviewLogs from '@/pages/business/requirement/FsReviewLogs';
import ReviewModal from '@/pages/project/review/components/ReviewModal';
import BackModal from '@/pages/business/requirement/components/BackModal';
import InvalidModal from '@/pages/business/requirement/components/InvalidModal';
import EvaluationBtn from '@/pages/business/requirement/components/EvaluationBtn';
import RetrospectModal from '@/pages/business/requirement/components/RetrospectModal';
import ActionRecordModal from '@/pages/business/document/components/ActionRecordModal';
import BrTeamAssessModal from '@/pages/business/requirement/components/BrTeamAssessModal';
import BrAssessConfirmModal from '@/pages/business/requirement/components/BrAssessConfirmModal';

export default {
  components: {
    BackModal,
    AddOrEdit,
    ReviewModal,
    FsReviewLogs,
    InvalidModal,
    EvaluationBtn,
    RetrospectModal,
    ActionRecordModal,
    BrTeamAssessModal,
    BrAssessConfirmModal
  },
  props: {
    dataSource: {
      type: Object,
      default: () => {
        return {};
      }
    },
    brType: {
      type: Number,
      default: 0
    },
    nextStatus: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      modalVisible: false,
      loading: {},
      reviewInfos: null,
      myTeamList: []
    };
  },
  computed: {
    isCrator() {
      const userId = this.$store.state.userInfo.id;
      if (userId === this.dataSource.creator) {
        return true;
      }
      return false;
    },
    // 产品运营
    isProductOperation() {
      const userId = this.$store.state.userInfo.id;
      if (this.dataSource.productOperation && this.dataSource.productOperation.includes(userId)) {
        return true;
      }
      return false;
    },
    // 产品PO
    isProductPo() {
      const userId = this.$store.state.userInfo.id;
      if (this.dataSource.po && this.dataSource.po.includes(userId)) {
        return true;
      }
      return false;
    },
    // 技术经理
    isTechnicalManager() {
      const userId = this.$store.state.userInfo.id;
      if (this.dataSource.technicalManager && this.dataSource.technicalManager.includes(userId)) {
        return true;
      }
      return false;
    },
    reviewPermission() {
      const userId = this.$store.state.userInfo.id;
      if (this.$store.state.globalConfigList) {
        const pmomList = this.$store.state.globalConfigList.pmom || [];
        const brPoList = this.$store.state.globalConfigList.br_po || [];
        if (pmomList.find(item => item.user_id === userId)) {
          return true;
        }
        if (brPoList.find(item => item.user_id === userId)) {
          return true;
        }
      }
      return false;
      // return true;
    },
    canReview() {
      const userId = this.$store.state.userInfo.id;
      if (this.$store.state.globalConfigList) {
        const orgList = this.$store.state.globalConfigList.pmom || [];
        const pmomUser = orgList.find(item => item.user_id === userId);
        if (!pmomUser) {
          return false;
        }
      }

      if (!this.reviewInfos) return false;
      if (this.reviewInfos.length === 0) return true;
      for (let index = 0; index < this.reviewInfos.length; index++) {
        const element = this.reviewInfos[index];
        if (element.status === 1 || element.status === 2) {
          return false;
        }
      }
      return true;
    }
  },
  watch: {},
  created() {
    this.getTeamList();
  },
  methods: {
    onBack() {
      this.$refs.backModalModalRef.onOpen();
      this.utils.trackClick({ name: '退回' });
    },
    onInvalid() {
      this.$refs.invalidModalRef.onOpen();
      this.utils.trackClick({ name: '作废' });
    },
    openRetrospect() {
      this.$refs.retrospectModalRef.onOpen(this.dataSource.retrospectType);
    },
    getReviewInfo(business_req_id) {
      queryReviewByBuReqId({ business_req_id: business_req_id || this.dataSource.id }).then(res => {
        if (res && res.data) {
          this.reviewInfos = res.data.items || [];
        } else {
          this.reviewInfos = [];
        }
      });
      // this.reviewInfos = [];
    },
    brClaim() {
      const self = this;
      this.$confirm({
        title: '确认',
        content: '确认认领当前需求吗?',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        async onOk() {
          const req = {
            brId: self.dataSource.id,
            userId: self.$store.state.userInfo.id,
            teamList: self.myTeamList || []
          };
          businessRequirementClaim(req).then(() => {
            self.$message.success('认领成功');
            self.$emit('brClaimOk', req);
          });
        }
      });
    },
    readBr() {
      const self = this;
      this.$confirm({
        title: '确认',
        content: '确认要将该需求文档标记为已读吗?',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        async onOk() {
          addActionRecord({
            targetId: self.dataSource.id,
            targetType: 'br',
            actionType: 'read'
          }).then(() => {
            self.$message.success('标记已读成功');
            self.$emit('readBrOk');
          });
        }
      });
    },
    openReviewLog() {
      this.$refs.fsReviewLogsRef.open(this.reviewInfos);
    },
    openReadList() {
      this.$refs.actionRecordRef.onOpen(this.dataSource.id, 'br');
    },
    getTeamList() {
      teamList({ user_id: this.$store.state.userInfo.id }).then(res => {
        const _list = res.data.items || [];
        this.myTeamList = _list.map(item => item.id);
      });
    },
    close() {
      this.modalVisible = false;
    },
    openReview() {
      this.modalVisible = true;
      const list = [];
      list.push(this.dataSource.businessPartner); // 主业务方
      if (!list.includes(this.dataSource.creator)) {
        list.push(this.dataSource.creator); // 提报方
      }
      this.pushListEl(list, this.dataSource.businessCorrelation); // 关联业务方
      this.pushListEl(list, this.dataSource.productOperation); // 产品运营
      this.pushListEl(list, this.dataSource.po); // PO
      this.pushListEl(list, this.dataSource.technicalManager); // 技术经理

      this.$refs.reviewModalRef.initMrdInfo(this.dataSource.title + '-线下评审', list, this.dataSource.id);
    },

    pushListEl(list, elementList) {
      if (elementList && elementList.length > 0) {
        for (const item of elementList) {
          if (!list.includes(item)) {
            list.push(item);
          }
        }
      }
    },

    onEdit() {
      this.$refs.addOrEditRef.open(true, this.dataSource);
    },

    onOk() {
      this.$emit('ok');
    }
  }
};
</script>
